import { ComparePersonalAccidentQuoteParams } from '@apis/PersonalAccidentQuoteApi';
import { getRoute } from '@utils/route';

export type PersonalAccidentQuoteComparePageParams = ComparePersonalAccidentQuoteParams

export const PERSONAL_ACCIDENT_QUOTE_COMPARE_PAGE_URL = '/personal-accident-insurance-quote-compare';

export const routePersonalAccidentQuoteComparePage = (searchParams: PersonalAccidentQuoteComparePageParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_COMPARE_PAGE_URL, { searchParams });
